module.exports = __webpack_public_path__ + "img/yjfk.46d6f88.svg";